import React, { useState } from 'react';

// --- SUBMÓDULOS DE FILTROS MODULARES ---
import FiltrosPolizas from './modulos/FiltrosPolizas';
import FiltrosRenovaciones from './modulos/FiltrosRenovaciones';
import FiltrosCobranzas from './modulos/FiltrosCobranzas';

// --- ICONOS SVG ---
const IconTrophy = () => (
    <svg className="w-4 h-4 text-amber-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 3v4a5 5 0 005 5h4a5 5 0 005-5V3M19 7h2a2 2 0 012 2v1a4 4 0 01-4 4h-1M5 7H3a2 2 0 00-2 2v1a4 4 0 004 4h1m5 4v6m-4 0h8" />
    </svg>
);

const CONFIG_MODULOS = {
    POLIZAS: {
        label: 'Pólizas',
        icon: '📑',
        activeClass: 'bg-gradient-to-r from-blue-600 to-indigo-700 text-white border-blue-600 shadow-md shadow-blue-900/20',
        inactiveClass: 'bg-blue-50/40 text-blue-800 border-blue-100 hover:bg-blue-100/60 hover:text-blue-900'
    },
    COBRANZA: {
        label: 'Cobranzas',
        icon: '💵',
        activeClass: 'bg-gradient-to-r from-emerald-500 to-teal-600 text-white border-emerald-500 shadow-md shadow-emerald-900/20',
        inactiveClass: 'bg-emerald-50/40 text-emerald-800 border-emerald-100 hover:bg-emerald-100/60 hover:text-emerald-900'
    },
    SINIESTROS: {
        label: 'Siniestros',
        icon: '🚨',
        activeClass: 'bg-gradient-to-r from-rose-500 to-red-600 text-white border-rose-500 shadow-md shadow-rose-900/20',
        inactiveClass: 'bg-rose-50/40 text-rose-800 border-rose-100 hover:bg-rose-100/60 hover:text-rose-900'
    },
    ENDOSOS: {
        label: 'Endosos',
        icon: '🔄',
        activeClass: 'bg-gradient-to-r from-sky-500 to-blue-600 text-white border-sky-500 shadow-md shadow-sky-900/20',
        inactiveClass: 'bg-sky-50/40 text-sky-800 border-sky-100 hover:bg-sky-100/60 hover:text-sky-900'
    },
    REFACTURACIONES: {
        label: 'Refacturaciones',
        icon: '⚡',
        activeClass: 'bg-gradient-to-r from-violet-600 to-purple-700 text-white border-violet-600 shadow-md shadow-violet-900/20',
        inactiveClass: 'bg-violet-50/40 text-violet-800 border-violet-100 hover:bg-violet-100/60 hover:text-violet-900'
    },
    ANULACIONES: {
        label: 'Anulaciones',
        icon: '🚫',
        activeClass: 'bg-gradient-to-r from-orange-600 to-red-600 text-white border-orange-600 shadow-md shadow-orange-900/20',
        inactiveClass: 'bg-orange-50/40 text-orange-850 border-orange-100 hover:bg-orange-100/60 hover:text-orange-950'
    },
    RENOVACIONES: {
        label: 'Renovaciones',
        icon: '⏳',
        activeClass: 'bg-gradient-to-r from-fuchsia-600 to-pink-700 text-white border-fuchsia-600 shadow-md shadow-fuchsia-900/20',
        inactiveClass: 'bg-fuchsia-50/40 text-fuchsia-800 border-fuchsia-100 hover:bg-fuchsia-100/60 hover:text-fuchsia-900'
    }
};

/**
 * FiltrosSidebar - Panel lateral orquestador de filtros del BI.
 */
const FiltrosSidebar = ({
    moduloRaiz,
    setModuloRaiz,
    isDbLoaded,
    opcionesFiltrosUnicas = {},
    multiFiltros = {},
    setMultiFiltros,
    agruparPor,
    setAgruparPor
}) => {
    // Control unificado del dropdown actualmente abierto para evitar superposiciones
    const [activeDropdown, setActiveDropdown] = useState(null);

    return (
        <aside className="w-80 shrink-0 bg-white border-r border-slate-200/80 overflow-y-auto p-5 flex flex-col gap-6 custom-scrollbar text-left h-full shadow-[2px_0_10px_-5px_rgba(0,0,0,0.02)]">
            
            {/* 1. SELECCIÓN DE ORIGEN DE DATOS */}
            <div className="space-y-3 text-left">
                <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest block">
                    1. Origen de Datos
                </label>

                {/* BOTÓN DESTACADO SANCOR 2026 */}
                <button
                    type="button"
                    onClick={() => setModuloRaiz('OBJETIVOS_SANCOR')}
                    className={`w-full py-2.5 px-3.5 rounded-xl font-black text-xs transition-all duration-200 flex items-center justify-between border select-none active:scale-95 hover:-translate-y-0.5 ${
                        moduloRaiz === 'OBJETIVOS_SANCOR'
                            ? 'bg-gradient-to-r from-amber-500 to-yellow-600 text-white border-amber-500 shadow-md shadow-amber-900/20 ring-2 ring-amber-400/30'
                            : 'bg-amber-50/50 text-amber-900 border-amber-200/80 hover:bg-amber-100/70'
                    }`}
                >
                    <div className="flex items-center gap-2">
                        <IconTrophy />
                        <span>Objetivos SANCOR</span>
                    </div>
                    <span className={`text-[9px] font-black px-2 py-0.5 rounded-full uppercase tracking-wider ${
                        moduloRaiz === 'OBJETIVOS_SANCOR' ? 'bg-white text-amber-900' : 'bg-amber-200/60 text-amber-900'
                    }`}>
                        2026
                    </span>
                </button>

                {/* GRILLA DE MÓDULOS RELACIONALES */}
                <div className="grid grid-cols-2 gap-2">
                    {Object.entries(CONFIG_MODULOS).map(([key, config]) => {
                        const isSelected = moduloRaiz === key;
                        return (
                            <button 
                                key={key} 
                                type="button"
                                onClick={() => setModuloRaiz(key)} 
                                className={`py-2.5 px-3 rounded-xl font-black text-[10px] tracking-wider border transition-all duration-200 flex items-center justify-center gap-2 select-none active:scale-95 hover:-translate-y-0.5 ${
                                    isSelected ? config.activeClass : config.inactiveClass
                                }`}
                            >
                                <span className="text-[12px]">{config.icon}</span>
                                <span>{config.label}</span>
                            </button>
                        );
                    })}
                </div>
            </div>

            {moduloRaiz !== 'OBJETIVOS_SANCOR' && (
                <>
                    {/* 2. CRITERIO DE AGRUPAMIENTO */}
                    {isDbLoaded && (
                        <div className="space-y-2.5 text-left pt-2 border-t border-slate-100">
                            <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest block">
                                2. Agrupar Previsualización
                            </label>
                            <select 
                                value={agruparPor} 
                                onChange={(e) => setAgruparPor(e.target.value)} 
                                className="w-full border border-slate-200 rounded-xl p-2.5 text-xs font-bold bg-white text-[#01032d] outline-none cursor-pointer transition-all hover:border-slate-300"
                            >
                                <option value="NINGUNO">LISTADO PLANO</option>
                                <option value="compania">COMPAÑÍA</option>
                                <option value="riesgo">RAMO / RIESGO</option>
                                {moduloRaiz === 'COBRANZA' ? (
                                    <>
                                        <option value="estado">ESTADO COBRO</option>
                                        <option value="quienCobro">QUIÉN COBRÓ</option>
                                        <option value="quienInformo">QUIÉN INFORMÓ</option>
                                    </>
                                ) : moduloRaiz === 'RENOVACIONES' ? (
                                    <>
                                        <option value="estadoGestionRenovacion">ESTADO RENOVACIÓN</option>
                                        <option value="quienRenovo">QUIÉN RENOVÓ</option>
                                        <option value="tipoRenovacion">TIPO RENOVACIÓN</option>
                                        <option value="motivo">TIPO DE OPERACIÓN</option>
                                        <option value="subOperacion">SUB OPERACIÓN</option>
                                        <option value="estadoEmision">ESTADO EMISIÓN</option>
                                    </>
                                ) : (
                                    <>
                                        <option value="canal">CANAL</option>
                                        <option value="estadoEmision">ESTADO EMISIÓN</option>
                                    </>
                                )}
                            </select>
                        </div>
                    )}

                    {/* 3. SEGMENTACIÓN DE MULTI-FILTROS POR SUBMÓDULO */}
                    {isDbLoaded ? (
                        <div className="space-y-4 text-left pt-2 border-t border-slate-100 animate-fade-in relative">
                            <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest block pb-1">
                                3. Filtros Secundarios
                            </label>

                            {moduloRaiz === 'COBRANZA' && (
                                <FiltrosCobranzas 
                                    opcionesFiltrosUnicas={opcionesFiltrosUnicas}
                                    multiFiltros={multiFiltros}
                                    setMultiFiltros={setMultiFiltros}
                                    activeDropdown={activeDropdown}
                                    setActiveDropdown={setActiveDropdown}
                                />
                            )}

                            {moduloRaiz === 'RENOVACIONES' && (
                                <FiltrosRenovaciones 
                                    opcionesFiltrosUnicas={opcionesFiltrosUnicas}
                                    multiFiltros={multiFiltros}
                                    setMultiFiltros={setMultiFiltros}
                                    activeDropdown={activeDropdown}
                                    setActiveDropdown={setActiveDropdown}
                                />
                            )}

                            {moduloRaiz !== 'COBRANZA' && moduloRaiz !== 'RENOVACIONES' && (
                                <FiltrosPolizas 
                                    opcionesFiltrosUnicas={opcionesFiltrosUnicas}
                                    multiFiltros={multiFiltros}
                                    setMultiFiltros={setMultiFiltros}
                                    activeDropdown={activeDropdown}
                                    setActiveDropdown={setActiveDropdown}
                                />
                            )}
                        </div>
                    ) : (
                        <div className="text-center py-8 px-4 bg-slate-50 border border-slate-100 rounded-2xl">
                            <p className="text-xs text-slate-400 font-bold uppercase tracking-wider">Esperando datos...</p>
                            <p className="text-[11px] text-slate-400 mt-1 leading-relaxed">Establece arriba el intervalo de consulta para clasificar.</p>
                        </div>
                    )}
                </>
            )}

            <style>{`
                .custom-scrollbar::-webkit-scrollbar { width: 5px; }
                .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
                .custom-scrollbar::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 10px; }
                .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #cbd5e1; }
                .animate-fade-in { animation: fadeIn 0.2s ease-out forwards; }
                @keyframes fadeIn { from { opacity: 0; transform: translateY(4px); } to { opacity: 1; transform: translateY(0); } }
            `}</style>
        </aside>
    );
};

export default FiltrosSidebar;